import { getCookie, setCookie } from './cookie';

export const getExternalId = () => getCookie('si-euid');

/**
 * This should only be called when a new external ID has been sent be the server.
 * @param {string} externalId The external ID for this session.
 */
export const setExternalId = externalId => setCookie('si-euid', externalId);
